import React from 'react';
import { VideoResourceType } from '../../../../api/types';
import {
  VideoCardDescription,
  VideoCardMainBody,
  VideoCardTitle,
  VideoPlayerContainer,
  VideoPlayerMask,
} from './VideoCard.styles';
import { VideoPlayer } from './VideoPlayer';

interface VideoCardProps {
  videoResourceType: VideoResourceType;
  className?: string;
  dataTestId?: string;
  onClick?: () => void;
}

export function VideoCard({ videoResourceType, className, dataTestId, onClick }: VideoCardProps) {
  const testId =
    dataTestId || `${videoResourceType.title.split(' ').join('-').toLowerCase()}-video-card`;

  return (
    <VideoCardMainBody className={className} data-testid={testId}>
      <VideoPlayerContainer>
        <VideoPlayerMask onClick={onClick} />
        <VideoPlayer url={videoResourceType.url} height={250} />
      </VideoPlayerContainer>

      <VideoCardTitle as="h3">{videoResourceType.title}</VideoCardTitle>

      <VideoCardDescription as="p">{videoResourceType.description}</VideoCardDescription>
    </VideoCardMainBody>
  );
}

export default VideoCard;
